import axios from "axios";

export default {
  generarSolicitudRecarga: function(importe, medio, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Cuenta/GenerarSolicitudRecarga`,
        {
          importe: importe,
          medio: medio
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  generarSolicitudRetiro: function(token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Cuenta/GenerarSolicitudRetiro`,
        {},
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  generarRecargaMercadopago: function(importe, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Cuenta/GenerarRecargaMercadoPago`,
        {
          importe: importe
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  obtenerUltimosMovimientos: function(dias, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Cuenta/ObtenerUltimosMovimientos`,
        { dias },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  obtenerSaldo: function(token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Cuenta/ObtenerSaldo`,
        {},
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  },

  subirImagen: function(imagen, tipo, token, handler) {
    axios
      .post(
        `${process.env.VUE_APP_SERVER_URL}/api/Cuenta/SubirImagen`,
        {
          imagen,
          tipo
        },
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      )
      .then(handler);
  }
};
